var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'component-timeline',
		this.$store.getters.getIsMobile ? 'mobile' : ''
	]},[(_vm.dataReady)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"menu"},[_c('Menu')],1),_c('div',{staticClass:"secondary-wrapper"},[_c('div',{staticClass:"mainSection"},[_c('MainSection')],1),(!this.$store.getters.getIsMobile)?_c('div',{staticClass:"ligne"},[_c('Ligne')],1):_vm._e()])]):_c('div',[_c('Spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }